const weight = 'bold';

export const chartOptions = (plugins: any, formatter: (value: any, context: any) => void = (value: any, context: any) => value.toLocaleString(),
    isContrast: boolean, chartBarYAxisHeader: string | string[], maxCharsPerLine: number, lineHeight: string, chartBarXAxisHeader?: string, displayLabels: boolean = true) => {
    return {
        scales: {
            x: {
                grid: { display: false },
                ticks: {
                    font: { weight, lineHeight },
                    color: isContrast ? '#00FFFF' : 'gray',
                    autoSkip: false,
                    callback: function (value: any, index: any, values: any) {
                        const label = this.getLabelForValue(value).toString();
                        const words = label.split(" ");
                        let lines = [];
                        let currentLine = "";
              
                        words.forEach((word: any) => {
                          if ((currentLine + " " + word).length > maxCharsPerLine) {
                            lines.push(currentLine);
                            currentLine = word;
                          } else {
                            currentLine += " " + word;
                          }
                        });

                        lines.push(currentLine);
                        return lines;
                    },
                    maxRotation: 0,
                    minRotation: 0,
                },
                title: { 
                    display: true,
                    text: chartBarXAxisHeader,
                    align: 'center',
                    font: { size: 14, weight },
                    color: isContrast ? '#00FFFF' : 'gray',
                },
            },
            y: {
                beginAtZero: true,
                ticks: {color: isContrast ? '#00FFFF' : 'gray'},
                title: { display: true, text: chartBarYAxisHeader, color: isContrast ? '#00FFFF' : 'gray', align: 'end', font: { size: 14, weight } },
            }
        },
        plugins: {
            ...plugins, 
            tooltip: {
                enabled: false // Disable tooltips here
            },
            datalabels: {
                display: displayLabels,
                color: isContrast ? 'white' : 'black',
                font: { weight },
                anchor: 'end',
                clamp: false,
                align: 'top',
                textAlign: 'center',
                formatter
            },
        },
        elements: { bar: { borderRadius: 10 } },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: 50
            }
        },
    }
};